module.exports = __webpack_public_path__ + "assets/img/11.f09fe493.png";